<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>Send test message</v-card-title>

        <v-card-text>
            <v-list>
                <v-list-item
                    v-for="(item, index) in choices"
                    :key="index"
                    v-on:click="onClick(item.value)"
                >
                    <v-list-item-icon>
                        <v-icon>{{item.icon}}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{item.title}}</v-list-item-title>
                        <v-list-item-subtitle>{{item.text}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
           
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            active_endpoint: null,
            conversation_id: null,

            choices: [
                { 'title' : 'Spin Forver', 'text' : 'A text message that will always be in transit', 'value' : 'spin-forever', 'icon' : 'mdi-chat-processing' },
                { 'title' : 'Error', 'text' : 'A text message that will fail to send (error)', 'value' : 'error', 'icon' : 'mdi-alert-circle' },
                { 'title' : 'Spam', 'text' : 'A message that the receiving carrier will mark as spam', 'value' : 'error-spam', 'icon' : 'mdi-cancel' },
                { 'title' : 'Text a Number That Does Not Support SMS', 'text' : 'A text message to a number that does not accept SMS', 'value' : 'error-no-sms', 'icon' : 'mdi-message-alert' },
                { 'title' : 'Image Error', 'text' : 'A image that will fail to send', 'value' : 'error-image', 'icon' : 'mdi-image-off' },
                { 'title' : 'Rich Error Message', 'text' : 'A message with a rich error message', 'value' : 'error-rich', 'icon' : 'mdi-alert-circle' },
            ],
        }
    },

    methods: {

        showDialog(active_endpoint, conversation_id)
        {
            this.active_endpoint = active_endpoint;
            this.conversation_id = conversation_id;

            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;
        },

        onCancel()
        {
            this.dialog = false;
        },

        onClick(code)
        {
            if ( code == 'spin-forever' )
            {
                let to_send = {
                    'active_endpoint': this.active_endpoint, 
                    'conversation_id': this.conversation_id, 
                    'text': 'redchirp_test: spin forver', 
                    'blob_ids': null, 
                    'send_images_as_links': null,
                    'category': 'conversational'
                };

                this.$rc.sendMessage(to_send);
            }

            if ( code == 'error' )
            {
                let to_send = {
                    'active_endpoint': this.active_endpoint, 
                    'conversation_id': this.conversation_id, 
                    'text': 'redchirp_test: always error', 
                    'blob_ids': null, 
                    'send_images_as_links': null,
                    'category': 'conversational'
                };

                this.$rc.sendMessage(to_send);
            }

            if ( code == 'error-no-sms' )
            {
                let to_send = {
                    'active_endpoint': this.active_endpoint, 
                    'conversation_id': this.conversation_id, 
                    'text': 'redchirp_test: phone number does not support sms', 
                    'blob_ids': null, 
                    'send_images_as_links': null,
                    'category': 'conversational'
                };

                this.$rc.sendMessage(to_send);
            }

            if ( code == 'error-image' )
            { 
                let to_send = {
                    'active_endpoint': this.active_endpoint, 
                    'conversation_id': this.conversation_id, 
                    'text': '', 
                    'blob_ids': ['f86110a3-72ec-4360-ab79-2e74b5c1f762'], 
                    'send_images_as_links': null,
                    'category': 'conversational'
                };

                this.$rc.sendMessage(to_send);
            }

            if ( code == 'error-rich' )
            {
                let to_send = {
                    'active_endpoint': this.active_endpoint, 
                    'conversation_id': this.conversation_id, 
                    'text': 'redchirp_test: rich error', 
                    'blob_ids': null, 
                    'send_images_as_links': null,
                    'category': 'conversational'
                };

                this.$rc.sendMessage(to_send);
            }

            if ( code == 'error-spam' )
            {
                let to_send = {
                    'active_endpoint': this.active_endpoint, 
                    'conversation_id': this.conversation_id, 
                    'text': 'redchirp_test: spam', 
                    'blob_ids': null, 
                    'send_images_as_links': null,
                    'category': 'conversational'
                };

                this.$rc.sendMessage(to_send);
            }

            

            this.dialog = false;
        }

    },
}
</script>

<style lang="scss" scoped>
</style>